/** Yalıda Davet · UI/domain constants (Turkish copy lives here). */
import type { SortOption } from './types.js';

export const BRAND = {
  name: 'Yalıda Davet',
  tagline: 'Özel yalılarda unutulmaz organizasyonlar',
} as const;

export const NAV_LINKS = [
  { key: 'home', label: 'Ana Sayfa', to: '/' },
  { key: 'listings', label: 'İlanlarım', to: '/ilanlarim' },
  { key: 'messages', label: 'Mesajlar', to: '/mesajlar' },
  { key: 'profile', label: 'Profil', to: '/profil' },
] as const;

export const QUICK_FILTERS = [
  { id: 'dugun', label: 'Düğün' },
  { id: 'nikah', label: 'Nikah' },
  { id: 'dogum-gunu', label: 'Doğum Günü' },
  { id: 'cinsiyet-aciklama', label: 'Cinsiyet Açıklama' },
  { id: 'afterparty', label: 'Afterparty' },
  { id: 'mezuniyet', label: 'Mezuniyet' },
] as const;

export const PROPERTY_TYPES = [
  { value: 'yali', label: 'Yalı' },
  { value: 'villa', label: 'Villa' },
  { value: 'kosk', label: 'Köşk' },
  { value: 'bahce', label: 'Bahçe' },
  { value: 'cati', label: 'Çatı Katı' },
  { value: 'tekne', label: 'Tekne' },
] as const;

export const LOCATIONS = [
  { value: 'Sarıyer', label: 'İstanbul · Sarıyer' },
  { value: 'Beykoz', label: 'İstanbul · Beykoz' },
  { value: 'Üsküdar', label: 'İstanbul · Üsküdar' },
  { value: 'Beşiktaş', label: 'İstanbul · Beşiktaş' },
  { value: 'Adalar', label: 'İstanbul · Adalar' },
  { value: 'Çeşme', label: 'İzmir · Çeşme' },
  { value: 'Bodrum', label: 'Muğla · Bodrum' },
] as const;

export const AMENITIES = [
  { key: 'hasPool', label: 'Havuzlu', testKey: 'pool', icon: 'waves' },
  { key: 'hasGarden', label: 'Bahçeli', testKey: 'garden', icon: 'trees' },
  { key: 'hasSeaView', label: 'Deniz Manzaralı', testKey: 'sea-view', icon: 'sailboat' },
  { key: 'hasParking', label: 'Otoparklı', testKey: 'parking', icon: 'car' },
] as const;

export const EXTRA_AMENITIES = [
  { key: 'hasWifi', label: 'Wi-Fi', icon: 'wifi' },
  { key: 'hasGenerator', label: 'Jeneratör', icon: 'zap' },
  { key: 'hasSoundSystem', label: 'Ses Sistemi', icon: 'speaker' },
  { key: 'isAccessible', label: 'Engelli Erişimi', icon: 'accessibility' },
  { key: 'hasStagingArea', label: 'Sahne / Kurulum Alanı', icon: 'layout' },
  { key: 'hasCateringArea', label: 'Catering Alanı', icon: 'utensils' },
  { key: 'hasMusicLicence', label: 'Müzik İzni', icon: 'music' },
] as const;

export const SORT_OPTIONS: { value: SortOption; label: string }[] = [
  { value: 'price_asc', label: 'Fiyata göre (Artan)' },
  { value: 'price_desc', label: 'Fiyata göre (Azalan)' },
  { value: 'rating_desc', label: 'Puana göre (Yüksek)' },
  { value: 'capacity_desc', label: 'Kapasiteye göre' },
  { value: 'garden_desc', label: 'Bahçe alanına göre' },
  { value: 'newest', label: 'En yeni ilanlar' },
];

/** Slider bounds — kuruş & m². */
export const PRICE_RANGE = { min: 0, max: 15_000_000, step: 100_000 }; // 0 – 150.000 ₺
export const AREA_RANGE = { min: 0, max: 2000, step: 10 }; // 0 – 2000 m²

export const HOST_STEPS = [
  { step: 1, key: 'photos', label: 'Fotoğraflar' },
  { step: 2, key: 'pricing', label: 'Fiyat ve Detaylar' },
  { step: 3, key: 'events', label: 'Organizasyon Tipleri' },
  { step: 4, key: 'documents', label: 'Belge Yükleme' },
] as const;

export const DOCUMENT_TYPES = [
  { value: 'tapu', label: 'Tapu / Kira Sözleşmesi', required: true },
  { value: 'kimlik', label: 'Kimlik Belgesi', required: true },
  { value: 'isletme_belgesi', label: 'İşletme Belgesi', required: false },
  { value: 'sigorta', label: 'Sigorta Poliçesi', required: false },
  { value: 'vergi_levhasi', label: 'Vergi Levhası', required: false },
  { value: 'muzik_izni', label: 'Müzik Yayın İzni', required: false },
] as const;

export const CHAT_SECURITY_WARNING =
  'Güvenliğiniz için ödemeleri ve iletişimi Yalıda Davet üzerinden gerçekleştirin. Platform dışı ödeme talepleri dolandırıcılık olabilir.';

export const NOISE_WARNING_TR = (curfew: string, deadline: string) =>
  `Bu mülk yerleşim bölgesindedir. Müzik yayını en geç ${curfew}'da sonlandırılmalı ve mülkten en geç ${deadline}'da çıkış yapılmalıdır. Gürültü yönetmeliğine uyulmaması durumunda depozito kesintisi uygulanır.`;
